module.exports = __webpack_public_path__ + "images/init/member-visitor@2x-cf97b000bec4bb6556e6b902bace7af6.png";